<template>
  <div id="pdf" style="top: 0px;left: 0px;right: 0px;bottom: 0px;background-color: white;font-size: 14px;font-family: sans-serif;overflow:scroll;">
    <div class="paper" style="width: 720px;margin: auto;">
      <table id="p-table" class="table w-full text-left whitespace-no-wrap">
        <thead class="bg-gray-200">
          <tr class="text-left">
            <th class="border p-2">Order ID</th>
            <th class="border p-2">Warehouse</th>
            <th v-if="currentUser.type!='Seller'" class="border p-1 text-center ">Seller</th>
            <th class="border p-1 text-center ">Shipping address</th>
            <th class="border p-2 text-center">Shipping date</th>
            <th class="border p-2 text-center">Customer</th>
            <th class="border p-2 text-center">Phone</th>
            <th class="border p-2 text-center">Phone2</th>
            <th class="border p-2 text-center">Order products</th>
            <th class="border p-2 text-center">Quantitys</th>
            <!-- <th class="border p-2 text-center">UnitPrices</th> -->
            <th class="border p-2 text-center">TotalPrice</th>
            <th class="border p-2 text-center">Trakingnumber</th>
            <th v-if="currentUser.type!='Seller'" class="border p-2 text-center">Livreur</th>
            <th class="border p-2 text-center">Status</th>
            <th v-if="currentUser.type!='Seller'" class="border p-2 text-center">Accounting</th>
            <th class="border p-2 text-center">Returned</th>
            <th v-if="currentUser.type!='Seller'" class="border p-2 text-center">teleConsultant</th>
            <th v-if="currentUser.type!='Seller'" class="border p-2 text-center">Nombre de reprogrammations</th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-if="items.length == 0">
            <th class="border p-3 bg-gray-100" colspan="15">
              No Shipping found
            </th>
          </tr>
          <tr class="text-center" v-for="(item, index) in items" :key="index" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
            <td class="border p-2">
              <span class="flex items-center">
                {{ $f.getIdbySplit(item.orderObjet.id.replace('#',''))  }}
              </span>
            </td>
            <td  class="border p-2">
              <span class="flex items-center">
                {{ idWharhouse.name }}
              </span>
            </td>
            <td v-if="currentUser.type!='Seller'" class="border p-2">
              <span class="flex items-center">
                {{ item.orderObjet.seller.fullName||item.orderObjet.seller.email }}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{ item.address?item.address.replace(/[^a-zA-Z 0-9]+/g,''):''}}
              </span>
            </td>
            <td class="border p-2">
              <span class="flex items-center">
                {{$moment(item.date).format("yyyy-MM-DD") }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.order.customer?item.order.customer.fullName?item.order.customer.fullName.replace(/[^a-zA-Z 0-9]+/g,''):'':'' }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.order.customer && item.order.customer.phone ? item.order.customer.phone : "" }}
              </span>
            </td>
              <td class="border p-2">
              <span class="flex items-center">
                {{ item.order.customer &&  item.order.customer.shippingPhone?item.order.customer.shippingPhone:'' }}
              </span>
            </td>
            <td class="border p-2  bg-green-100">
              {{ sumProduct(item.order.details) }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ sumQuantity(item.order.details)}}
            </td>
             <!-- <td class="border p-2  bg-green-100">
              {{ sumQunitPrices(item.order.details) }}
            </td> -->
             <td class="border p-2  bg-green-100">
              {{ item.order.totalPrice }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.trackingNumber }}
            </td>
             <td v-if="currentUser.type!='Seller'" class="border p-2  bg-green-100">
              {{ item.courier?item.courier.fullName||item.courier.email:"" }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ item.status }}
            </td>
             <td v-if="currentUser.type!='Seller'" class="border p-2  bg-green-100">
              {{ item.accounting?item.accounting.fullName||item.accounting.email:""}}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.comment?item.comment:"" }}
            </td>

            <td v-if="currentUser.type!='Seller'" class="border p-2  bg-green-100">
              {{  item.orderObjet.teleConsultantConfirm && item.orderObjet.teleConsultantConfirm.fullName ? item.orderObjet.teleConsultantConfirm.fullName.replace(/[^a-zA-Z 0-9]+/g,'') : "System|Admin"  }}
            </td>

            <td v-if="currentUser.type!='Seller'" class="border p-2  bg-green-100">
              {{ item.reprogrammedCount||0 }}
            </td>
           
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    currentUser: { type: Object},
     idWharhouse: { type: Object}
  },
  mounted() {
    // const pdf = document.querySelector("#pdf").cloneNode(true);
    // document.querySelector("#app").before(pdf);
    // document.querySelector("#app").style.display = "none";
    // window.print();
    // pdf.remove();
    // document.querySelector("#app").style.display = "block";
    // this.exportToExcel()
    // this.$emit("printed");
    console.log('items excel____',this.items)
  },
  methods: {
    // getRestDays(endDate) {
    //   return this.$options.filters.toDays(endDate, Date.now());
    // },
    sumQteProduct(data){
      let sum=0;
      for (let i in data) {
        sum=sum+data[i].quantity;
      }
      return sum;
    },
    sumQuantity(data) {
      if (!Array.isArray(data)) return "";

      return data
        .filter(item => item && item.quantity != null)
        .map(item => item.quantity)
        .join(", ");
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        if(data[i].product && data[i].product.name) product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    sumQunitPrices(data){
      let unitPrices="";
      for (let i in data) {
        if(data[i].unitPrice){
         unitPrices+=data[i].unitPrice.toString()
         if(data.length-1 != i) unitPrices+=" ,"; 
        }
       
      }
      return unitPrices;
    },
  }
};
</script>
<style>
table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
thead {
  display: table-header-group;
}
tfoot {
  display: table-footer-group;
}
</style>
